import { authenticatedInstance } from '../index/index.service';

type ClientLogLevel = 'debug' | 'info' | 'warn' | 'error';

// Summary: Fire-and-forget browser→backend diagnostic logger; posts structured lines to the public /client-logs sink (CloudWatch) and never throws.
// Details: docs/function-library/web/services.md#client-log-service
export function logToBackend(scope: string, message: string, data?: unknown, level: ClientLogLevel = 'info'): void {
  try {
    if (process.env.NODE_ENV === 'test') {
      return;
    }
    const token = process.env.REACT_APP_CLIENT_LOG_TOKEN;
    void authenticatedInstance
      .post('/client-logs', { scope, level, message, data: sanitize(data) }, {
        headers: token ? { 'x-client-log-token': token } : undefined,
      })
      .catch(() => undefined);
  } catch {
    // Diagnostics must never break the calling flow.
  }
}

// Drops values that cannot be JSON-serialised (circular refs, functions) so the post body is always valid.
function sanitize(data: unknown): unknown {
  if (data === undefined) {
    return undefined;
  }
  try {
    return JSON.parse(JSON.stringify(data));
  } catch {
    return { unserializable: String(data) };
  }
}
